module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-546.4cdd281.woff2";